import RadioGroup from "../inputs/RadioGroup";
import { CombinedInputFieldsetProps } from "./FieldsetProps";
import TextInput from "../inputs/TextInput";
import { RadioButtonField, TextInputField } from "../inputs/InputProps";

import "./Fieldset.scss";

const DoubleDocumentFee: React.FC<CombinedInputFieldsetProps> = ({
    currentSelection,
    setCurrentSelection,
    textInputValue,
    setInputValue,
}) => {
    const fields: RadioButtonField[] = [
        {
            id: "0",
            label: `Yes, there is more than one title incorporated in this document.`,
        },
        {
            id: "1",
            label: "No, there is only one title incorporated in this document.",
        },
    ];

    const textField: TextInputField = {
        id: "2",
        labelHidden: false,
        label: "How many titles are incorporated in this document?",
        type: "number",
    };

    return (
        <fieldset className="fee-calc-fieldset">
            <legend>
                <i className="fa fa-asterisk" aria-hidden="true" title="Required"></i>
                <span className="sr-only">Required</span>
                Is there more than one title incorporated in this document?
            </legend>
            <RadioGroup
                currentSelection={currentSelection}
                setCurrentSelection={setCurrentSelection}
                fieldsetId="DoubleDocumentFee"
                fields={fields}
            />
            {currentSelection === "0" && (
                <TextInput
                    value={textInputValue}
                    handleFieldChange={setInputValue}
                    field={textField}
                    fieldsetId="DoubleDocumentFee"
                />
            )}
        </fieldset>
    );
};

export default DoubleDocumentFee;
